export class DevicesConstants {
    static readonly SLASH_DEVICE = '/device';
    static readonly SLASH_USERS = '/users';
    static readonly SLASH = '/';
    static readonly PARAM_RETAILERID = '?retailerids=';
    static readonly PARAM_PAGENUMBER = '?pagenumber=';
    static readonly SLASH_DOWNLOAD = '/download';
    static readonly SLASH_REPORT = '/report';
    static readonly STROEID_PARAMS = '?storeids=';
    static readonly SEARCH_BY = '?searchby=';
    static readonly SORT_BY = '&sortby=';
    static readonly SLASH_UPLOAD = '/upload';
    static readonly SLASH_RETAILERS = '/retailers';
    static readonly SLASH_STORES = '/stores';
    static readonly RETAIL_HQ_ROLE = 'retailHQUser';
    static readonly RETAILER_NAME_CHECK = '?retailername=';
    static readonly DEVICES = 'devices';
    static readonly SORTBY = '?sortby=';
    static readonly SORT_TYPE = '&sorttype=';
    static readonly SKUID_SORT = 'skuid';
    static readonly DEVICE_UUID_SORT = 'deviceid';
    static readonly DEVICE_NAME_SORT = 'devicename';
    static readonly RETAILER_NAME_SORT = 'retailername';
    static readonly CONNECTIVITY_STATUS_SORT = 'connectivityStatus';
    static readonly STORE_NAME_SORT = 'storename';
    static readonly STORE_NUMBER_SORT = 'storenumber';
    static readonly BRAND_SORT = 'brand';
    static readonly CHART = '/chart';
    static readonly SLASH_DEVICES = '/devices';
    static readonly DEVICE_TYPE_SORT = 'devicetype';
    static readonly PROFILE_PUSH_SORT = 'profilePushStatus';
    static readonly LEGAL_VERSION_SORT = 'iposLegalVersion';
    static readonly UPGRADE_TIME_SORT = 'profileUpgradeDateTime';
    static readonly PREVIOUS_PUSH_TIME_SORT = 'profilePreviousPushTime';
    static readonly SEGMENT_SORT = 'segmentheadline';
    static readonly LAST_UPDATE_SORT = 'deviceupdatedtime';
    static readonly LAST_CONNECTED_SORT = 'lastConnectedTime';
    static readonly EMPTY_VALUE = '';
    static readonly ASCENDING_ORDER = 'asc';
    static readonly DESCENDING_ORDER = 'desc';
    static readonly CONNECTIVITY_STATUS_HOVER = $localize`:@@devices.hover-text.connectivity-status:Hover on connectivity status column to view the details`;
    static readonly UPDATE_ICON_HOVER = $localize`:@@devices.hover-text.update-edit:Update`;
    static readonly REMOVE_ICON_HOVER = $localize`:@@devices.hover-text.remove-device:Remove Device`;
    static readonly UPDATE_VIA_CSV = $localize`:@@devices.hover-text.update-via-csv:Update via CSV`;
    static readonly UPDATE_VIA_CSV_HOVER = $localize`:@@devices.hover-text.download-edit-csv-label:Download and edit the CSV template to quickly push updates to many devices.`;
    static readonly DOWNLOAD_MULTIPLE_REPORTS = $localize`:@@devices.hover-text.download-multiple-report:Select multiple stores to download a combined device report CSV.`;
    static readonly DOWNLOAD_FULL_REPORTS = $localize`:@@devices.hover-text.download-full-report-csv-details:The full device report CSV details all information about your stores and their connected devices.`;
    static readonly ACTIVE_DEVICES = $localize`:@@devices.hover-text.active-devices:Active Devices have been online within the last 30 days.`;
    static readonly STORE_ID = $localize`:@@devices.update-popup.store-id:Store ID`;
    static readonly DEVICE_UUID = $localize`:@@devices.update-popup.store-id:Device UUID`;
    static readonly LAST_UPDATE = $localize`:@@devices.update-popup.last-updated:Last Updated`;
    static readonly DEVICE_NAME_SEARCH = 'devicenamesearch';
    static readonly SKUID_SEARCH = 'skusearch';
    static readonly STORE_NAME_SEARCH = 'storenamesearch';
    static readonly STORE_NUMBER_SEARCH = 'storenumbersearch';
    static readonly DEVICE_TYPE_SEARCH = 'devicetypesearch';
    static readonly SEGMENT_SEARCH = 'segmentsearch';
    static readonly UUID_SEARCH = 'deviceidsearch';
    static readonly PROCESSOR_MODEL_SEARCH = 'processormodelsearch';
    static readonly LOAD_FLAG = 'Y';
    static readonly UNLOAD_FLAG = 'N';
    static readonly SEARCH_QUERY = '?';
    static readonly EQUALS = '=';
    static readonly DEVICENAME = $localize`:@@device-dashboard.dropdown.device-name:Device Name`;
    static readonly SKUID = $localize`:@@device-dashboard.dropdown.sku-id:SKU ID`;
    static readonly STORENAME = $localize`:@@device-dashboard.dropdown.store-name:Store Name`;
    static readonly STORENUMBER = $localize`:@@device-dashboard.dropdown.store-number:Store Number`;
    static readonly DEVICETYPE = $localize`:@@device-dashboard.dropdown.device-type:Device Type`;
    static readonly SEGMENT = $localize`:@@device-dashboard.dropdown.segment:Segment`;
    static readonly UUID = $localize`:@@device-dashboard.dropdown.uuid:UUID`;
    static readonly PROCESSOR_MODEL = $localize`:@@device-dashboard.dropdown.processor-model:Processor Model`;
    static readonly CONNECTIVITY_STATUS_VALUE_FILTER = 'connectivitystatus';
    static readonly SEGMENT_VALUE_FILTER = 'segmentHeadlinefilter';
    static readonly CONTENT_TYPE_VALUE_FILTER = 'contentTypefilter';
    static readonly SKU_ID_TYPE_FILTER = 'skuIDfilter';
    static readonly BRAND_VALUE_FILTER = 'brandfilter';
    static readonly DEVICE_TYPE_VALUE_FILTER = 'deviceTypefilter';
    static readonly PROCESSORS_VALUE_FILTER = 'processorfilter';
    static readonly OPERATING_SYSTEM_VALUE_FILTER = 'operatingSystemfilter';
    static readonly PUSH_STATUS_VALUE_FILTER = 'profilePushStatusfilter';
    static readonly VERSION_NUMBER_VALUE_FILTER = 'iposLegalVersionfilter';
    static readonly GAMING_NONGAMING_DEVICE_VALUE_FILTER = 'isGamingBattlefilter';
    static readonly DOWNLOAD = 'download';
    static readonly REMOVE_ONE_DEVICE = $localize`:@@devices.remove-popup.remove-device:Remove Device`;
    static readonly REMOVE_MULTIPLE_DEVICE = $localize`:@@devices.remove-popup.remove-devices:Remove Devices`;
    static readonly REMOVE_ONE_SRT_DEVICE = 'Remove Device';
    static readonly REMOVE_MULTIPLE_SRT_DEVICE = 'Remove Devices';
    static readonly DEVICE_ID_EQUELS = '?deviceid=';
    static readonly SEARCH_TEXT = $localize`:@@devices.search.search-label:Search...`;
    static readonly HIDE_FILTERS = $localize`:@@devices.filters.hide-filters:Hide Filters`;
    static readonly OPERATING_SYSTEMS = $localize`:@@devices.filters.operating-systems:Operating Systems`;
    static readonly PROCESSORES = $localize`:@@devices.filters.processors:Processors`;
    static readonly DEVICE_TYPES = $localize`:@@devices.filters.device-types:Device Types`;
    static readonly BRANDS = $localize`:@@devices.filters.brands:Brands`;
    static readonly DEVICE_PASSWORD_IS_REQUIRED = $localize`:@@devices.password-popup.password-required:Password is required`;
    static readonly DEVICE_PASSWORD_ERROR_MESSAGE = $localize`:@@devices.password-popup.password-error-message:Password must contain at least 5 characters`;
    static readonly DEVICE_PASSWORD_MATCH = $localize`:@@devices.password-popup.password-not-match:Password doesn’t match`;
    static readonly DEVICE_UPDATE_SAVED = $localize`:@@devices.password-popup.update-save:Updates Saved`;
    static readonly DEVICE_UPDATE_DESC = $localize`:@@devices.password-popup.update-description:Push Updates to send your saved updates to these devices`;
    static readonly DEVICE_MASTER = 'Primary'; // changing it as primary as per recent
    static readonly DEVICE_SPECIFICATION = 'device_specification';
    static readonly DEVICE_EXPLORE_THIS_PC = 'EXPLORE THIS PC';
    static readonly DEVICE_PASSWORDS = 'passwords';
    static readonly DEVICE_CUSTOMIZABLE_BUTTON = 'Customizable Button';
    static readonly DEVICE_IDLE_EXPERIENCE = 'Idle Experience';
    static readonly DEVICE_CANCEL_TITLE = $localize`:@@devices-info.popup.cancel-popup-title:Cancel Updates?`;
    static readonly DEVICE_CANCEL_DESC = $localize`:@@devices-info.popup.cancel-popup-description:You have updates that haven’t been pushed yet. Are you sure you want to cancel your update?`;
    static readonly NO = $localize`:@@devices-info.popup.button-label-no:No`;
    static readonly CANCEL_UPDATE = $localize`:@@devices-info.popup.button-label-cancel:Cancel Update`;
    static readonly ENTER_BUTTON_COPY = $localize`:@@devices-settings.button-copy:Enter button copy here`;
    static readonly ENTER_URL = $localize`:@@devices-settings.enter-url:Enter URL here`;
    static readonly ENTER_TYPE_PASSWORD = $localize`:@@devices.password-popup.enter-type-password:Enter Password`;
    static readonly CONFIRM_TYPE_PASSWORD = $localize`:@@devices.password-popup.confirm-type-password:Confirm Password`;
    static readonly URL = 'url';
    static readonly MASTER_PASSWORD_ON_DEVICE = $localize`:@@devices.password-popup.change-master-password-on-device:Change the primary password on all devices.`;
    static readonly UNINSTALL_PASSWORD_ON_DEVICE = $localize`:@@devices.password-popup.change-uninstall-password-on-device:Change the Uninstall Password on all devices.`;
    static readonly SUCCESS_MASTER_PASSWORD = $localize`:@@devices.password-popup.master-password-update:Primary Password Updated`;
    static readonly SUCCESS_MASTER_PASSWORD_DESC = $localize`:@@devices.password-popup.master-password-update-desc:The primary password has been updated on all devices.`;
    static readonly SUCCESS_UNINSTALL_PASSWORD = $localize`:@@devices.password-popup.uninstall-password-update:Uninstall Password Updated`;
    static readonly SUCCESS_UNINSTALL_PASSWORD_DESC = $localize`:@@devices.password-popup.uninstall-password-update-desc:The Uninstall Password has been updated on all devices.`;
    static readonly SUCCESS_IDLE_DESC = $localize`:@@devices.success-popup.idle-success-desc:Your changes to idle experience will be pushed to all devices`;
    static readonly SUCCESS_CUSTOMIZABLE_DESC = $localize`:@@devices.success-popup.customizable-success-desc:Your changes to customizable button will be pushed to all devices`;
    // IIT2-1510
    static readonly STORE_LOGO_DESC = $localize`:@@devices-storelogo.changes-to-logo-content.desc:Your changes to logo content or store logo will be pushed to all devices.`;
    // IIT2-1510 end 
    static readonly PUSH_UPDATES_TO_DEVICE = $localize`:@@devices.push-update-popup.push-device-title:Push updates to device?`;
    static readonly PUSH_UPDATES = $localize`:@@devices.push-update-popup.push-update-btn:Push Updates`;
    static readonly UPDATES_PUSHED = $localize`:@@devices.push-update-popup.sucess:Updates pushed`;
    static readonly CANCEL = $localize`:@@devices.push-update-popup.cancel-btn:Cancel`;
    static readonly PAGE_NUMBER = '&pagenumber';
    static readonly WINDOWS_OS = $localize `:@@profile-info.dropdown-menu.windows:Windows*`;
    static readonly LINUX_OS = $localize `:@@profile-info.dropdown-menu.linux:Linux*/Devices with no operating systems`;
    static readonly WINDOWSUWP_OS = $localize `:@@profile-info.dropdown-menu.uwp:UWP for Windows* in S Mode`;
    static readonly DEVICE_TYPE = 'device_type';
    static readonly DEVICE_DESKTOP = 'Desktop';
    static readonly DEVICE_STANDARD_DESKTOP = 'Standard Desktop';
    static readonly DEVICE_ALLINONE = 'AllinOne';
    static readonly DEVICE_ALLINONE_DESKTOP = 'All-in-one Desktop';
    static readonly STOREDEVICECOUNT = 'storedevicecount';
    static readonly GENERATEDBY = 'generatedby';
    static readonly LASTGENERATED = 'lastgenerated';
    static readonly  STORECOUNT = 'storecount';
    static readonly RETAILERNAME = 'retailername';
    static readonly DATE_FORMATTER = 'MM/dd/yy';
    static readonly AUTO_SHUTDOWN = $localize`:@@device-dashboard.auto-heading.auto-shutdown:AUTO-SHUTDOWN`;
    static readonly AUTO_SHUTDOWN_TITLE = $localize`:@@ipos-help.oda.setting-autoshut-occur:Shutdown will occur if the device is idle during the last 30 minutes prior to time set, but will be extended 30 minutes past last detected activity.`;
    static readonly SHUTDOWN_ENABLE = 'autoShutdownEnable';
    static readonly SHUTDOWN_DISABLE = 'autoShutdownDisable';
    static readonly AUTO_SHUTDOWN_NOTE = $localize`:@@device-dashboard.auto-shutdown-note:Note:`;
    static readonly AUTO_SHUTDOWN_NOTE_TEXT = $localize`:@@device-dashboard.auto-shutdown-note-text:These changes will reflect only on devices with internet connectivity running IPOS packages generated after October 2022.`;
    static readonly PRICE_SUPPRESS ="?isPriceSupress=";
    static readonly GENERATE_STATUS = 'generated';
    static readonly GENERATING_STATUS = 'generating';
    static readonly GENERATE_POP_OVER_CLASS = 'options_popup option_hover';
    static readonly PROFILES_HIDE_CLASS = 'existing_profiles_hide'; 
    static readonly EXISTING_PROFILES_CLASS = 'existing_profiles_show';
    static readonly PROFILES_DOWNLOAD_CLASS = 'existing_profiles_show_gen_downld';
    static readonly INACTIVE = 'Inactive';
    static readonly RECENTLY_CONNECTED = 'Recently Connected';
    static readonly DISCONNECTED = 'Disconnected';
    static readonly CONNECTED = 'Connected';
    static readonly TWO_WEEKS = '2+ Weeks disconnected';
    static readonly NO_STORE_ID= 'stNstore';
    static readonly NO_SKU_ID= '-- No SKU ID --';
    static readonly ASSET_LIB= 'asset-library';
    static readonly PUSH_NEW_DEVICE= '/pushToNewDevice';
    static readonly PARAM_UNISONDEMO = '&unisonDemo=';
    static readonly UNISONDEMO = 'unisonDemo';
    
    static readonly SLASH_SRT= '/srt';
    static readonly RETAILERID = '?retailerid=';
    static readonly SRT_DEVICE_ID_FILTER = 'srtDeviceIdFilter';
    static readonly SRT_STORE_NAME_FILTER = 'storenamefilter';
    static readonly SRT_VERSION_FILTER = 'srtversionfilter';
    static readonly SRT_VERSION_TEXT = 'PC Finder Version';
    static readonly SRT_VERSION = 'srtversion';
    static readonly SRT_LAST_UPDATE = 'deviceUpdatedTime';
    static readonly SRT_SYNC_STATUS = 'syncStatus';
    static readonly SRT_DEVICE_ID_TEXT = 'PC Finder Device ID';
    static readonly SRT_DEVICE_ID_SEARCH = 'deviceidsearch';
    static readonly NON_BATTLE_GAME_STATION = $localize`:@@device-dashboard.non-battle-station-devices-filter-name:Non-Battle station devices`;
    static readonly BATTLE_GAME_STATION = $localize`:@@device-dashboard.battle-station-devices-filter-name:Battle station devices`;
    // For IGC-12
    static readonly SRT_SYNC_STATUS_TEXT = 'Sync Status';
    static readonly DEVICE_UPDATED_TIME = 'Device Updated Time';
    static readonly SRT_LAST_CONNECTED_TIME = 'Last Connected Time';
    static readonly SRT_DEVICE_CSV_FILENAME = 'Device CSV_PC Finder';
    static readonly PC_FINDER_DEVICE_UUID = 'Pc Finder Device ID';
    static readonly PUSH_UPDATES_TO_SRT_DEVICE = $localize`:@@device-dashboard.are-you-sure-to-push-updates-to-devices:Are you sure you want to push Updates to the devices?`;
    //IIT2-10050
    static readonly PUSH_STATUS = $localize`:@@device-dashboard.push-status-column:Push Status`;
    static readonly LAST_CONNECTED = $localize`:@@device-dashboard.last-connected-column:Last Connected`;
    static readonly VERSION_NUMBER = 'Version Number';

    static readonly PUSHED_TEXT = 'pushed';
    static readonly DWNLD_INPRG = 'downloadInProgress';
    static readonly DWNLD_CMPTD = 'downloadCompleted';
    static readonly INSTALL_START = 'installationStart';
    static readonly SYNCHED_TEXT = 'synched';
    static readonly DWNLD_FAILED = 'downloadFailed';
    static readonly INSTALL_FAILED = 'installationFailed';
    static readonly CONNECTED_STATUS_HOVER_TEXT =  $localize`:@@device-dashboard.successfully-connected-past-six-hours:IPOS has successfully connected to the device in the past six hours.`;
    static readonly DISCONNECTED_STATUS_HOVER_TEXT = $localize`:@@device-dashboard.unable-to-connect-for-over-six-hours:IPOS has been unable to connect to the device for over six hours.`;
    static readonly TWO_WEEKS_DISCONNECTED_HOVER_TEXT = $localize`:@@device-dashboard.not-connected-more-than-fourteen-days:This indicates that IPOS has not been connected to the device for more than 14 days.`;
    // IIT2-13197
    static readonly IS_DEVICE_EVO_VALUE_FILTER = 'isDeviceEvofilter';
    static readonly EVO_DEVICES = $localize`:@@device-dashboard.evo-device-filter.evo-devices:Intel® Evo™ designs`;
    static readonly NON_EVO_DEVICES = $localize`:@@device-dashboard.non-evo-device-filter.non-evo-devices:Non-Intel® Evo™ designs`;
    static readonly PROFILE_SEARCH_BY = 'profileNameSearch';
    static readonly PAGE_NUMBER_ONE = '&pagenumber=1';
    static readonly QUERY_PAGE_NUMBER_ONE = '?pagenumber=1';
    static readonly SYSTEMID_SEARCH = 'systemidsearch';
}

export enum Enumvalues {
    VALUE_1 = '1',
    VALUE_2 = '2',
    VALUE_3 = '3',
    VALUE_4 = '4',
    VALUE_5 = '5',
    VALUE_6 = '6',
    VALUE_7 = '7',
    VALUE_8 = '8'
}
